import * as allStatuses from 'statuses'
const statuses = (allStatuses as any).default || allStatuses

export const message = statuses.message as typeof import('statuses').message

export default statuses
